'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAttachments = undefined;

var _immutable = require('immutable');

var _reduce = require('transmute/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

var _EmailMetadata = require('../records/EmailMetadata');

var _EmailMetadata2 = _interopRequireDefault(_EmailMetadata);

var _FileAttachment = require('../records/FileAttachment');

var _FileAttachment2 = _interopRequireDefault(_FileAttachment);

var _QuickReplyAttachment = require('../records/QuickReplyAttachment');

var _QuickReplyAttachment2 = _interopRequireDefault(_QuickReplyAttachment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildAttachments = exports.buildAttachments = function buildAttachments(attachments) {
  return (0, _reduce2.default)((0, _immutable.List)(), function (attachmentList, attachment) {
    var attachmentType = attachment[_messageTypes.MESSAGE_TYPE_ID];
    switch (attachmentType) {
      case _attachmentTypes.EMAIL_METADATA:
        return attachmentList.push((0, _EmailMetadata2.default)((0, _immutable.fromJS)(attachment)));
      case _attachmentTypes.FILES:
        return attachmentList.push((0, _FileAttachment2.default)((0, _immutable.fromJS)(attachment)));
      case _attachmentTypes.QUICK_REPLIES:
        return attachmentList.push(new _QuickReplyAttachment2.default(attachment));
      default:
        return attachmentList;
    }
  }, attachments || (0, _immutable.List)());
};